import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/DocumentOptionalFields/DocumentOptionalFields.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loader } from '../../../components/loader/Loader';
import { useTranslation } from '../../../context/translationContext';
import { paths } from '../../RouterContainer';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { DocumentOptionalFieldsForm } from '../../../forms/DocumentOptionalFields/DocumentOptionalFieldsForm';
import { DocumentOptionalField } from '../../../types/Invoice';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useLoading } from '../../../context/loadingContext';

/**
 * Page component for editing existing optional field of document
 */
export const DocumentOptionalFieldsUpdatePage = () => {
  const { companyId, id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState<DocumentOptionalField | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();
  const { startLoading, stopLoading } = useLoading();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
          paths.OPTIONAL_FIELDS
        }/edit/${id}`,
        name: 'navigation.company-optional-fields-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.OPTIONAL_FIELDS },
    });

  /**
   * Loads optional field
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.OPTIONAL_FIELD_ITEM}?id=${id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles edit action for optional field form submit.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({
        url: apiUrl.OPTIONAL_FIELD_UPDATE,
        data: values,
      });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (data === null) return <Loader />;
  return (
    <div className="w-1/4	space-y-8">
      <h1 className="text-3xl font-bold">{t('page.optional-field.headline-edit')}</h1>
      <DocumentOptionalFieldsForm
        initialValues={data as Values}
        onSubmit={handleSubmit}
        onBack={handleOnBack}
      />
    </div>
  );
};
